export const dispatch = (type: string, payload?: any) => ({ type, payload });
